// src/features/developers/contact.ts

/** Where «Solicitar acceso» writes to: the Roommatik support address the API already publishes as its contact. */
export const ACCESS_REQUEST_ADDRESS = 'support@roommatik.com';

export const accessRequestHref = (subject: string, body: string): string =>
  `mailto:${ACCESS_REQUEST_ADDRESS}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
